import React from 'react';
import "./footer.css"
import Beard from '../../assets/images/logo-beard.svg'
import Phone from '../../assets/icons/phone.svg'
import Email from '../../assets/icons/email.svg'
import Whatsapp from '../../assets/icons/whatsapp.svg'
import Youtube from '../../assets/icons/youtube.svg'
import Instagram from '../../assets/icons/instagram.svg'
import Img1 from '../../assets/images/samandehi.svg'
import Img2 from '../../assets/images/enamad.svg'
import ArrowTop from '../../assets/icons/arrow-top.svg'

const Footer = () => {
  // Function to scroll to the top of the page
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll effect
    });
  };
  return (
    <div>
      <div className='footer container'>
        <div className='top-btn'>
          <div className='top-btn-left'></div>
          <div className='top-btn-right'></div>
          <button className='btn' onClick={handleScrollToTop}><img src={ArrowTop} alt="" /></button>

        </div>
        <img src={Beard} alt="" style={{ position: 'absolute', right: '1em', top: '1.2em' }} />
        <div className='row w-100'>
          <div className=' col-4'>

            <div className=' mr-5'>
              <h5 className='text-white text-2xl title-footer' style={{ textWrap: 'nowrap' }}>کادونا،<span style={{fontSize:'16px'}}> نسل جدید کارتهای بانکی</span></h5>
              <div className='d-flex text-base text-white font-medium mt-5 gap-3'><img src={Phone} alt="" /> تماس با ما: ۹۲۰۰۱۶۰۸ - ٠٢١ </div>
              <div className='d-flex text-base text-white font-medium mt-3 gap-3'><img src={Email} alt="" /> پست الکترونیک: cs@kadoona.ir </div>
            </div>

          </div>
          <div className=' text-center col-4' >
            <div className='d-flex footer-item align-items-center gap-2 justify-content-center'>
              <div className='item'>
                <img src={Img1} alt="" />
              </div>
              <div className='item'>
                <a target='_blank' href='https://trustseal.enamad.ir/?id=306660&Code=fETqHuKC4Bz8LQTDaSy8'>
                  <img src='https://trustseal.enamad.ir/logo.aspx?id=306660&Code=fETqHuKC4Bz8LQTDaSy8' alt="eNamad" style={{ cursor: 'pointer' }} />
                </a>
              </div>
            </div>
            <div className='d-flex align-items-center gap-2 mt-3 justify-content-center'>
              <h6 className='text-base text-white text-2xl'>شبکه‌های اجتماعی</h6>
              {/* <img src={Youtube} alt="" /> */}
              {/* <img src={Whatsapp} alt="" /> */}
              <a href='https://www.instagram.com/kadoona.ir'><img src={Instagram} alt="" /></a>
            </div>

          </div>
          <div className='d-flex align-items-start col-4'>
            <ul>
              <li><a href='/categories' className='text-base text-right text-white font-medium' style={{ textWrap: 'nowrap' }}>دسته بندی ها</a></li>
              <li ><a href='/activation' className='text-base text-right text-white font-medium mt-3' style={{ textWrap: 'nowrap' }}>شارژ و فعالسازی</a></li>
              <li><a href='/about-us' className='text-base text-right text-white font-medium mt-3' style={{ textWrap: 'nowrap' }}>درباره ما</a></li>
              <li ><a href='/contact-us' className='text-base text-right text-white font-medium mt-3' style={{ textWrap: 'nowrap' }}>ارتباط با ما</a></li>
            </ul>
            <ul>
              <li ><a href='/catalog' className='text-base text-right text-white font-medium' style={{ textWrap: 'nowrap' }}>کاتالوگ</a></li>
              <li ><a href='/faq' className='text-base text-right text-white font-medium' style={{ textWrap: 'nowrap' }}>سوالات متداول</a></li>
              <li ><a href='https://cafebazaar.ir/app/com.sepas.kadoona' className='text-base text-right text-white font-medium mt-3' style={{ textWrap: 'nowrap' }}>دریافت اپلیکیشن کادونا</a></li>
              {/* <li ><a className='text-base text-right text-white font-medium mt-3' style={{textWrap: 'nowrap'}}>فهرست و درخواست نمایندگی</a></li> */}
              <li ><a href='/rules' className='text-base text-right text-white font-medium mt-3'> مقررات وحریم خصوصی کاربران</a></li>
            </ul>
          </div>

        </div>
      </div>
      <h6 className='text-xs font-normal mt-3  text-center' style={{ color: '#0033CC' }}>تمامی حقوق مادی و معنوی این وبسایت متعلق به کادونا می باشد . </h6>
    </div>
  );
}

export default Footer;
